/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Injectable } from '@angular/core';
import { Params, Router, UrlTree } from '@angular/router';

import { Store } from '@ngxs/store';
import moment from 'moment-timezone';
import { AuthenticationService } from 'rest-client';
import { Observable, of } from 'rxjs';

import {
  getFormattedDateFromParams,
  getStartDate,
  DATE_TIME_FORMAT,
  getEndDate,
} from '@app/modules/shared/const/date-picker.consts';
import { getPlaceIdfromCommonTerminalId } from '@app/modules/shared/const/terminals.consts';
import { InitialBookingData } from '@app/modules/shared/models';
import {
  SetBookingDatesAction,
  SetBookingInitialDataAction,
} from '@core/states/booking-state/booking.actions';
import {SetCommonTerminalsAction, SetPromoCodeAction} from '@core/states/trip-state/trip.actions';

const PARKING = 'parking';

@Injectable({
  providedIn: 'root',
})
export class ProcessQueryParams {
  urlExceptions: string[];

  constructor(
    private store: Store,
    private router: Router,
    private authService: AuthenticationService
  ) {}

  process(params: Params): Observable<boolean> | Observable<UrlTree> {
    const {
      in_common_terminal_id,
      out_common_terminal_id,
      start_date,
      end_date,
      source_mode,
      modify_res_token,
      agent_token,
      reservation_token,
      focus,
      absuid,
      promocode,
    } = params;

    const formattedParams: InitialBookingData = {
      startDate: getFormattedDateFromParams(start_date),
      endDate: getFormattedDateFromParams(end_date),
      placeId: getPlaceIdfromCommonTerminalId(in_common_terminal_id),
      inTerminal:
        Number(in_common_terminal_id) > 0
          ? Number(in_common_terminal_id)
          : null,
      outTerminal:
        Number(out_common_terminal_id) > 0
          ? Number(out_common_terminal_id)
          : null,
      source_mode: source_mode ? (source_mode as string) : PARKING,
      promocode: promocode ? promocode : null,
    };

    if (!!formattedParams.startDate && !!formattedParams.endDate) {
      if (moment(formattedParams.endDate).isBefore(formattedParams.startDate)) {
        formattedParams.startDate = moment(
          getStartDate(),
          DATE_TIME_FORMAT
        ).format();
        formattedParams.endDate = moment(
          getEndDate(),
          DATE_TIME_FORMAT
        ).format();
      }
    }

    if (focus && focus === 'billing_data') {
      return this.navigateToTraveler();
    }

    if (modify_res_token || agent_token) {
      return this.navigateToServices();
    }

    if (absuid) {
    }

    if (reservation_token) {
      return this.navigateToConfirmation();
    }

    return !!formattedParams.startDate &&
      !!formattedParams.endDate &&
      !!formattedParams.inTerminal &&
      !!formattedParams.outTerminal &&
      !!formattedParams.placeId
      ? this.setQueryParams(formattedParams)
      : this.navigateToWhereAndWhen(formattedParams);
  }

  private navigateToTraveler(): Observable<UrlTree> {
    return of(this.router.parseUrl('traveler-data'));
  }

  private navigateToServices(): Observable<UrlTree> {
    return of(this.router.parseUrl('services'));
  }

  private navigateToConfirmation(): Observable<UrlTree> {
    return of(this.router.parseUrl('confirmation'));
  }

  private setQueryParams(p: InitialBookingData): Observable<boolean> {
    this.setBookingStore(p.startDate, p.endDate, p.placeId);
    this.setTripStore(p.inTerminal, p.outTerminal);
    return of(true);
  }

  private navigateToWhereAndWhen(
    formattedParams: InitialBookingData
  ): Observable<UrlTree> {
    if (!!formattedParams.startDate && !!formattedParams.endDate) {
      this.store.dispatch(
        new SetBookingDatesAction(
          formattedParams.startDate,
          formattedParams.endDate
        )
      );
    }
    if (!!formattedParams.inTerminal) {
      this.setTripStore(formattedParams.inTerminal, null);
    }
    return of(this.router.parseUrl('where-when'));
  }

  private setBookingStore(
    startDate: string,
    endDate: string,
    placeId: number
  ): void {
    this.store.dispatch(
      new SetBookingInitialDataAction(startDate, endDate, placeId)
    );
  }

  private setTripStore(inTerminal: number, outTerminal: number): void {
    this.store.dispatch(new SetCommonTerminalsAction(inTerminal, outTerminal));
  }
}
